export default "__VITE_ASSET__BFLjQEtH__"